import React from "react";
import NotifySuccess from "./NotifySuccess";
import NotifyError from "./NotifyError";
import NotifyWarn from "./NotifyWarn";
import ChatClose from "./ChatClose";
import CollapseIcon from "./CollapseIcon";
import ExpandIcon from "./ExpandIcon";

interface Props {
  name: string;
  // className?: string;
  color?: string;
  size?: number | string;
  width?: number | string;
}

const Icon: React.FC<Props> = (props: Props) => {
  const { name, size = 16, color } = props;
  const svgIcons: any = {
    "notify-success": <NotifySuccess width={`${size}`} />,
    "notify-error": <NotifyError width={`${size}`} />,
    "notify-warn": <NotifyWarn width={`${size}`} />,
    "chat-close": <ChatClose width={`${size}`} />,
    "collapse-icon": <CollapseIcon width={`${size}`} color={color} />,
    "expand-icon": <ExpandIcon width={`${size}`} color={color}/>,
  };
  return <>{svgIcons[name]}</>;
};

export default Icon;
